import { useConsent } from '../contexts/ConsentContext'
import { Button } from '../design-system/components'
import { useTranslation } from 'react-i18next'

export default function CookieConsent() {
  const { consent, setAnalyticsConsent } = useConsent()
  const { t } = useTranslation()

  if (consent.analytics) return null

  return (
    <div className="fixed inset-x-0 bottom-0 z-50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-4">
        <div className="rounded-lg bg-white shadow-lg border border-gray-200 p-4 sm:p-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <p className="text-sm text-gray-700">
            {t('cookieConsent.message')}
          </p>
          <div className="flex gap-2 justify-end">
            <Button variant="outline" onClick={() => setAnalyticsConsent(false)}>
              {t('cookieConsent.rejectAnalytics')}
            </Button>
            <Button className="btn-primary" onClick={() => setAnalyticsConsent(true)}>
              {t('cookieConsent.acceptAnalytics')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}


